module.exports = __webpack_public_path__ + "static/media/brasilprev.daf9c7b4.svg";